import _ from 'underscore';
import { useMemo, useCallback } from 'react';
import { AccountUtils } from '@bingads-webui-clientcenter/entity-utils';
import useSwr from 'swr';

import {
  fetchEntityGridCombined,
} from '@bingads-webui-campaign/overview-cards-common';

import { TDataRequestSortDirection } from './types';

export interface IUseCombinedCallDataProps {
  dateRange: {
    RangeStartDate: string;
    RangeEndDate: string;
    compared: object;
  },
  filter: {
    filter: {
      key: number;
      value: object;
    }
  }[],
  campaignType: string | number;
  constructOptions: () => { entitySet: object };
  permissions: any;
  jsdata: any;
  dateUtil: any;
  getCardsConfig: () => { id: string }[];
  sortColumn: string | number;
  sortDirection: TDataRequestSortDirection;
  willFetchData: Function;
  willRender: Function;
}

export function useCombinedCallData({
  dateRange,
  filter,
  campaignType,
  constructOptions,
  permissions,
  jsdata,
  dateUtil,
  getCardsConfig,
  sortColumn,
  sortDirection,
  willFetchData,
  willRender,
}: IUseCombinedCallDataProps) {
  const {
    entitySet,
  } = constructOptions();
  const orderByValue = useMemo(() => [[sortColumn, sortDirection]], [sortColumn, sortDirection]);

  const fetch = useCallback(({ dateRange, filter, orderBy }) => {
    willFetchData();
    return fetchEntityGridCombined({
      entitySet,
      dateRange,
      comparisonDateRange: dateRange.compared,
      orderBy,
      jsdata,
      dateUtil,
      getCardsConfig,
      // TODO: [yaoyao] when orderBy is ready, we need to figure out how to set value for fetchSingleTile
      fetchSingleTile: false,
      filter,
      permissions,
      // now we only have expert mode?
      accountsMode: 1,
      campaignType,
    }).then((data) => {
      willRender();

      if (data?.[0]?.AccountInactiveReasons) {
        return _.map(data, entity => ({ ...entity, Status: AccountUtils.activityStatus(entity) }));
      }

      return data;
    });
  }, [willFetchData, entitySet, jsdata, dateUtil, getCardsConfig, permissions, willRender, campaignType]);

  const { data, isLoading } = useSwr({ dateRange, filter, orderBy: orderByValue }, fetch, {
    revalidateOnFocus: false,
  });

  return {
    data,
    isLoading,
  };
}
